const innerTextStyle = {
  color: "mediumGray",
  fontWeight: "600",
  mt: "1",
};

const subtitle = {
  color: "mediumGray",
  flex: 1 / 3,
  fontSize: 1,
  fontWeight: "500",
  lineHeight: "1.4",
};

const content = {
  color: "black",
  flex: 2 / 3,
  fontSize: 1,
  fontWeight: "600",
  lineHeight: "1.4",
};

export { content, subtitle, innerTextStyle };
